// extracted by mini-css-extract-plugin
module.exports = {"carousel":"QuoteSliderWrapper_carousel__1lsFz","mobile-navigation":"QuoteSliderWrapper_mobile-navigation__urX9k","tablet-navigation":"QuoteSliderWrapper_tablet-navigation__pLxCP"};